import { PbhRequestedInfoType } from "../../../Enums/PbhRequestedInfoType";
import { WaitingResponseType } from "../../../Enums/WaitingResponseType";

export class PbhWaitingResponseCreateModel {
  public RequestId?: number;
  public PbhRequestedInfoEnum?: PbhRequestedInfoType;
  public WaitingResponseEnum?: WaitingResponseType;
  public PbhWaitingResponseRemarkCreateModel: PbhWaitingResponseRemarkCreateModel | undefined;
}

export class PbhWaitingResponseRemarkCreateModel {
  public PbhWaitingResponseId?: number;
  public Remark?: string;
  public IsCustomer?: boolean;
}
